import { OrganizationJoinFromInvitation } from './AcceptInvitation'
import { OrganizationCreate } from './Create'
import { OrganizationJoin } from './Join'
import { OrganizationSelect } from './Select'
import { OrganizationJoinFromOauth } from './FromOauth'

import { Route, Switch } from 'react-router'
import { NotFound } from '../NotFound'
import { GoogleOneTapContext } from '../../components/GoogleOneTapContext'

const isSuperDomain =
  typeof window !== 'undefined' &&
  window.location.hostname.endsWith('super.work')

export function Organization() {
  return (
    <Switch>
      <Route path="/organization/create">
        <GoogleOneTapContext>
          <OrganizationCreate superEnabled={isSuperDomain} />
        </GoogleOneTapContext>
      </Route>
      <Route path={['/organization/ask/create', '/organization/super/create']}>
        <GoogleOneTapContext>
          <OrganizationCreate superEnabled />
        </GoogleOneTapContext>
      </Route>
      <Route path="/organization/join/:inviteToken">
        <OrganizationJoinFromInvitation superEnabled={isSuperDomain} />
      </Route>
      <Route path="/organization/super/join/:inviteToken">
        <OrganizationJoinFromInvitation superEnabled />
      </Route>
      <Route path="/organization/join-link/:domain/:organizationInviteToken/:joinOrigin?">
        <OrganizationJoin />
      </Route>
      <Route path="/organization/super/join-link/:domain/:organizationInviteToken/:joinOrigin?">
        <OrganizationJoin superEnabled />
      </Route>
      <Route path="/organization/select">
        <OrganizationSelect superEnabled={isSuperDomain} />
      </Route>
      <Route path={['/organization/super/select', '/organization/ask/select']}>
        <OrganizationSelect superEnabled />
      </Route>
      <Route path="/organization/create-from-oauth">
        <OrganizationJoinFromOauth superEnabled={isSuperDomain} />
      </Route>
      <Route path="/organization/autojoin/:domain/:membershipStatus?">
        <OrganizationJoin superEnabled={isSuperDomain} />
      </Route>
      <Route path="/organization/super/autojoin/:domain/:membershipStatus?">
        <OrganizationJoin superEnabled />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  )
}
